// extracted by mini-css-extract-plugin
module.exports = {"ActivityContainer":"Activity_ActivityContainer__2QptU","wrapper":"Activity_wrapper__mZSgK","arrowContainer":"Activity_arrowContainer__1Uj1v","showNav":"Activity_showNav__2vjj8"};